import { IAuthor, IOfferAuthor } from '../../../types';

const getName = (author: IOfferAuthor) => {
  return author.displayName || author.id;
};

export const prepareAuthor = (author: IOfferAuthor | null | undefined): IAuthor => {
  if (!author) {
    return {
      name: null,
      bank: null,
      avatar: null,
      fromDeveloper: null,
      isFromBuilder: null,
      cianId: null,
      workTimeInfo: null,
      trustInfo: null,
      agentLists: null,
      realtyUserId: null,
      agentAvailability: { available: true },
      qualityLevelInfo: null,
    };
  }

  return {
    agentLists: author.agentLists,
    avatar: author.avatar,
    bank: author.bank,
    cianId: author.cianId,
    fromDeveloper: author.fromDeveloper,
    isChatsEnabled: author.isChatsEnabled,
    isFromBuilder: author.isFromBuilder,
    isFromLeadFactory: author.isFromLeadFactory,
    name: getName(author),
    realtyUserId: author.realtyId,
    trustInfo: author.trustInfo,
    workTimeInfo: author.workTimeInfo,
    agentAvailability: author.agentAvailability || { available: true },
    qualityLevelInfo: author.qualityLevelInfo,
  };
};
